module.exports = __webpack_public_path__ + "static/media/tour-rec-orange.8e116d0f.svg";